import React from 'react'
import { Message } from 'semantic-ui-react'

//@ts-ignore
import './snackbar.css'

const SemanticUiReactSnackbar = ({ variant, children }) => {
  const getClass = () => {
    switch (variant) {
      case 'success':
        return 'success'
      case 'failed':
        return 'failed'
      default:
        return 'default'
    }
  }

  return (
    <Message className={getClass()}>
      <span>{children}</span>
    </Message>
  )
}

export default SemanticUiReactSnackbar
